export default function editorIos() {

    function parseDataConteudo(rawContent) {
        if (!rawContent || typeof rawContent !== 'string' || rawContent.trim() === '') {
            console.warn('data-conteudo-pt vazio ou não é string válida:', rawContent);
            return null;
        }

        const desescapedContent = rawContent
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');

        try {
            const parsed = JSON.parse(desescapedContent);

            if (!parsed.blocks || !Array.isArray(parsed.blocks)) {
                console.error('Estrutura de blocos inválida no data-conteudo-pt:', parsed);
                return null;
            }

            return parsed;
        } catch (error) {
            console.error('Erro ao fazer parse do data-conteudo-pt:', error, 'Conteúdo recebido:', desescapedContent);
            return null;
        }
    }

    function makerEditorTags(editor) {
        const dataAttr = editor.querySelector('[data-conteudo-pt]');
        if (!dataAttr) {
            console.warn('Elemento com [data-conteudo-pt] não encontrado dentro do editor:', editor);
            return;
        }

        const rawContent = dataAttr.getAttribute('data-conteudo-pt');
        if (!rawContent || rawContent.trim() === '') {
            console.warn('Atributo data-conteudo-pt está vazio ou não definido:', dataAttr);
            return;
        }

        const Texto = parseDataConteudo(rawContent);
        if (!Texto) return;

        let ResultText = '';
        const TotalTag = Texto.blocks.length;

        for (let i = 0; i < TotalTag; i++) {
            const Tipo = Texto.blocks[i].type;
            switch (Tipo) {
                case 'paragraph':
                    ResultText += `<p>${Texto.blocks[i].data.text}</p>`;
                    break;
                case 'Header':
                    const Level = Texto.blocks[i].data.level;
                    ResultText += `<h${Level}>${Texto.blocks[i].data.text}</h${Level}>`;
                    break;
                case 'List':
                    ResultText += `<ul class='${Texto.blocks[i]?.data?.style || ''}'>`;
                    for (let k of Texto.blocks[i].data.items) {
                        ResultText += `<li>${k}</li>`;
                    }
                    ResultText += `</ul>`;
                    break;
                case 'Image':
                    const { file, caption } = Texto.blocks[i].data;
                    const alt = caption || '';
                    const isVideoLink = alt.includes('youtube.com') || alt.includes('youtu.be') || alt.includes('vimeo.com');
                    if (isVideoLink) {
                        ResultText += `
                            <div class="video-wrapper" data-video="${alt}">
                                <img src="${file.url}" alt="${alt}" class="video-thumb" style="cursor:pointer;" />
                            </div>`;
                    } else {
                        ResultText += `<img src="${file.url}" alt="${alt}" />`;
                    }
                    break;
                case 'Embed':
                    ResultText += `
                        <div class="wrapper-embed">
                            <div class="embed ${Texto.blocks[i].data.service}">
                                <iframe width="${Texto.blocks[i].data.width}" height="${Texto.blocks[i].data.height}" src="${Texto.blocks[i].data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                            </div>
                        </div>`;
                    break;
            }
        }

        editor.innerHTML = ResultText;
    }

    const EditorTags = document.querySelectorAll('[js-editor-tags-textos]');
    if (EditorTags) {
        EditorTags.forEach((editor) => {
            makerEditorTags(editor);
        });
    }
}
